export default "__VITE_ASSET__52809249__"